export default "__VITE_ASSET__nedyZ7dd__"